export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff4f9948f744b2fdafeca513f45e39b48d725ca13&name=fetchTypeahead!'